import React from "react";

const ListingText = ({listing}) => {
    return <div>
        {listing && <ul className="bullets_listing">
            {listing.map((item, index) => {
                return <li key={index}>{item.value}</li>;
            })}
        </ul>}
    </div>
}

export default ListingText;


// WEBPACK FOOTER //
// ./src/components/ListingText.js